export function formatMoney(m, { sign = false } = {}) {
  if (!Number.isFinite(m)) return '';
  const rounded = Math.round(m * 10) / 10;
  const abs = Math.abs(rounded);
  const body = abs.toFixed(rounded % 1 === 0 ? 0 : 1);
  if (sign && rounded > 0) return `+$${body}M`;
  if (rounded < 0) return `-$${body}M`;
  return `$${body}M`;
}

// TWh for annual energy, GW for peak demand and firm capacity. The
// magnitudes are readable game numbers rather than a real system's, but
// this pairing is the one that reads plausibly on both axes at once:
// 45 TWh against a 14 GW peak is a ~37% load factor, roughly Ireland or
// Denmark. The previous MWh/MW labels put the same numbers at 0.04%.
export function formatTwh(v) {
  if (!Number.isFinite(v)) return '';
  return `${(Math.round(v * 10) / 10).toFixed(1)} TWh`;
}

export function formatGw(v) {
  if (!Number.isFinite(v)) return '';
  return `${roundGw(v).toFixed(1)} GW`;
}

// The value formatGw will display. Breakdowns round each part before
// deriving the rest, so a column of GW figures always adds up on
// screen — rounding each part independently leaves 1.0 + 0.1 = 1.2.
export function roundGw(v) {
  return Number.isFinite(v) ? Math.round(v * 10) / 10 : 0;
}

export function formatEmissions(v) {
  if (!Number.isFinite(v)) return '';
  if (v > 0) return `+${v}`;
  return `${v}`;
}

export function formatPercent(p) {
  if (!Number.isFinite(p)) return '';
  return `${Math.round(p * 100)}%`;
}

export function formatPlantOutput(plant, rolledOutputs, multiplier = 1) {
  if (typeof plant.output === 'number') {
    const output = plant.output * multiplier;
    return multiplier === 1 ? `${plant.output} TWh` : formatTwh(output);
  }
  const rolled = rolledOutputs?.[plant.id];
  if (Number.isFinite(rolled)) {
    return formatTwh(rolled * multiplier);
  }
  const min = plant.output.min * multiplier;
  const max = plant.output.max * multiplier;
  const formatEndpoint = (v) =>
    (Math.round(v * 10) / 10).toFixed(v % 1 === 0 ? 0 : 1);
  return `${formatEndpoint(min)} to ${formatEndpoint(max)} TWh`;
}
